import type { Board } from '../../../../schema/coupon/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import { getBoardCartesianProducts } from '../systems/getCartesianProducts.js';
import { getDefinitionReductionSum } from './getDefinitionReductionSum.js';

type QueryOptionsType = {
  definition: Definition;
};

/**
 * Selects the system size for a given coupon and board. This should not be mixed with coupon price or bet amount.
 *
 * @param board Coupon board
 * @param root0 Query options
 * @param root0.definition Product definition
 * @returns The system size for the given coupon and board
 */
export function selectSystemSize(board: Board, { definition }: QueryOptionsType): number {
  const engineReductionSum = getDefinitionReductionSum(definition);

  return getBoardCartesianProducts(board, engineReductionSum).reduce(
    (sum, selections) => sum * (selections.length || 1),
    1
  );
}
